import { _ as l } from "../internals/export.js";
import { g as o } from "../internals/global.js";
l({
  global: !0,
  forced: o.globalThis !== o
}, {
  globalThis: o
});